import React from 'react'

export default class Footer extends React.Component {
   render() {


      return (
        <div id="footer" className="footer navbar-fixed-bottom"  >
            <div className="container">
                <p className="muted credit">Cogniscreen&copy; 2017. </p>
            </div>
        </div>
      )
   }
}



// WEBPACK FOOTER //
// ./src/components/footer/Footer.jsx